import React, {useEffect, useState, useId} from "react"
import {observer} from "mobx-react-lite"
import { singletonFetch } from 'MODULES/singletonFetch'

export const OpeningDaysCalendarThisWeek = observer(function OpeningDaysCalendarThisWeek(props) {

    const id = useId();

	const [openingDays, setOpeningDays] = useState(props.openingDays)

	const UpdateOpeningDays = async function() {
		return await singletonFetch(
			'update_opening_days_this_week_' + id,
			props.updateOpeningDaysRestUrl + '?' + new URLSearchParams({
				offset: props.args.offset
			}),
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			}
		).then(response => {
			return response.json()
		}).then(data => {
			if(data.openingDays) {
				setOpeningDays(data.openingDays)
			}
		})
	}

	useEffect(() => {
		UpdateOpeningDays()
	}, [])

	return (
		<React.Fragment>
			<h4>{props.args.title}</h4>
            <div className="inner">
              {openingDays.map(openingDay => {
                return (
                  <div className="day-wrapper" key={openingDay.date}>
                    <span className="day">{openingDay.week_day}:</span>
                    <span className="hours">{openingDay.opening_day_type.formatted_opening_time}</span>
                  </div>
                )
              })}
            </div>
		</React.Fragment>
	)
})
